/**
 * The unit-record columns added for the CFO's expanded sheet (2026-10-13), in the groups his
 * workbook puts them in. They are ordinary Property Fields columns; the sheet keeps them
 * folded away until a viewer asks for a group, so the everyday sheet stays the width it was.
 * Each viewer's choice lives in their own browser.
 */
export const EXTRA_COLUMN_GROUPS = [
  { id: "unitDetails", label: "Unit details", keys: ["floor", "bed", "bath", "affordableUnit", "unitCondition", "scheduledRepairs"] },
  { id: "insuranceUtilities", label: "Insurance & utilities", keys: ["insuranceProvider", "insuranceReviewed", "submeteringAccount", "landlordCharges"] },
  { id: "leasePlanning", label: "Lease planning", keys: ["incentives", "expectedActionAtLeaseEnd", "tenantRating"] },
];

const GROUP_OF_KEY = new Map(EXTRA_COLUMN_GROUPS.flatMap((g) => g.keys.map((k) => [k, g.id])));

/** The extra group a column belongs to, or null for an everyday column. */
export const extraGroupOf = (key) => GROUP_OF_KEY.get(key) || null;

const STORAGE_KEY = "mastersheet.extraColumnGroups";

/** Group ids the viewer has switched on. Storage can be blocked or cleared: then none. */
export const loadShownGroups = () => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(saved) ? saved.filter((id) => EXTRA_COLUMN_GROUPS.some((g) => g.id === id)) : [];
  } catch (e) {
    return [];
  }
};

export const saveShownGroups = (ids) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch (e) {
    // A viewer without storage simply starts folded next time.
  }
};

/** Pure: the columns to draw, and the groups this sheet actually has columns for. */
export const applyExtraGroups = (columns, shownGroups) => ({
  visibleColumns: columns.filter((c) => {
    const group = extraGroupOf(c.key);
    return !group || shownGroups.includes(group);
  }),
  availableGroups: EXTRA_COLUMN_GROUPS.filter((g) => columns.some((c) => extraGroupOf(c.key) === g.id)),
});
